export default "__VITE_ASSET__ebf6b9b7__"